import { useState } from 'react';
import classNames from 'classnames';
import moment from 'moment';
import {
  LocationsAssigned,
  VibeButton,
  viCopy,
} from 'vibeguide';
import AdProgramCopyPreview from './AdProgramCopyPreview';

const {
  ADMIN_COMPANY_ID: adminCompanyId,
} = process.env;

function AdProgramCopy({
  className = '',
  currTime,
  locationId,
  adProgramId,
  strategy = null,
  onClose = () => {},
}) {
  const [data, setData] = useState({
    locations: [],
    locationsData: {
      companies: [],
      locations: [],
    },
  });
  const [showPreview, setShowPreview] = useState(false);

  const onUpdateLocations = ({
    locations,
    locationsData,
  }) => {
    setData({
      locations,
      locationsData,
    });
  };

  const onClickCopy = () => {
    setShowPreview(true);
  };

  const onCloseCopy = () => {
    setShowPreview(false);
  };

  return (
    <div
      className={classNames('AdProgramCopy', className)}
      style={{
        height: '100%',
      }}
    >
      <LocationsAssigned
        companyId={adminCompanyId}
        locations={data.locations}
        locationsData={data.locationsData}
        filtersUnassigned={{
          adProgramEnabled: true,
        }}
        customToolbar={(
          <VibeButton
            text="Copy Ad Program"
            icon={viCopy}
            color="success"
            disabled={data.locations.length <= 0}
            style={{
              marginRight: 8,
            }}
            testId="ad-program-copy-confirm-button"
            onClick={onClickCopy}
          />
        )}
        allowCompanies
        onUpdate={onUpdateLocations}
        onClose={onClose}
      />

      <AdProgramCopyPreview
        show={showPreview}
        currTime={currTime}
        locationId={locationId}
        adProgramId={adProgramId}
        locations={data.locations}
        strategy={strategy}
        onClose={onCloseCopy}
        onSuccess={onClose}
      />
    </div>
  );
}

export default AdProgramCopy;
